/**
 * Required by `@generativ/much-smarter-models` JsonProperty decorators
 * (`Reflect.metadata`).
 */
import 'reflect-metadata';

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';
